export const CONTENT_TYPES = {
  HEADER: 1,
  TEXT: 0
};
